/**
 * <sigla-rail>: a horizontally scrolling row with previous/next buttons.
 * Native scroll and swipe do the work; the buttons just move one card at a time.
 */
if (!customElements.get('sigla-rail')) {
  class SiglaRail extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-rail-track]');
      if (!this.track) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.buttons = [...this.querySelectorAll('[data-rail-direction]')];
      const controls = this.querySelector('[data-rail-controls]');
      if (controls) controls.hidden = false;
      this.buttons.forEach((button) =>
        button.addEventListener('click', () => this.move(Number(button.dataset.railDirection)), { signal })
      );
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const cards = [...this.track.children];
      if (!cards.length) return;
      const origin = cards[0].offsetLeft;
      const current = cards.reduce(
        (best, card, i) =>
          Math.abs(card.offsetLeft - origin - this.track.scrollLeft) <
          Math.abs(cards[best].offsetLeft - origin - this.track.scrollLeft)
            ? i
            : best,
        0
      );
      const target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
      const instant = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: target.offsetLeft - origin, behavior: instant ? 'auto' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.buttons.forEach((button) => {
        button.disabled =
          Number(button.dataset.railDirection) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('sigla-rail', SiglaRail);
}
